/* b2s-lang-switcher.js — language switcher with INLINE SVG FLAGS (Windows-compatible) */
(function(){
  'use strict';

  /* Inline SVG flags — render everywhere (no emoji font dependency) */
  const FLAGS = {
    en: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><clipPath id="t"><path d="M30,15h30v15zv15h-30zh-30v-15zv-15h30z"/></clipPath><path d="M0,0v30h60v-30z" fill="#012169"/><path d="M0,0 60,30M60,0 0,30" stroke="#fff" stroke-width="6"/><path d="M0,0 60,30M60,0 0,30" clip-path="url(#t)" stroke="#C8102E" stroke-width="4"/><path d="M30,0v30M0,15h60" stroke="#fff" stroke-width="10"/><path d="M30,0v30M0,15h60" stroke="#C8102E" stroke-width="6"/></svg>',
    fr: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><rect width="20" height="30" fill="#002654"/><rect x="20" width="20" height="30" fill="#fff"/><rect x="40" width="20" height="30" fill="#ED2939"/></svg>',
    de: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><rect width="60" height="10" fill="#000"/><rect y="10" width="60" height="10" fill="#DD0000"/><rect y="20" width="60" height="10" fill="#FFCE00"/></svg>',
    es: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><rect width="60" height="30" fill="#C60B1E"/><rect y="7.5" width="60" height="15" fill="#FFC400"/></svg>',
    nl: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><rect width="60" height="10" fill="#AE1C28"/><rect y="10" width="60" height="10" fill="#fff"/><rect y="20" width="60" height="10" fill="#21468B"/></svg>',
    it: '<svg viewBox="0 0 60 30" xmlns="http://www.w3.org/2000/svg" width="22" height="14"><rect width="20" height="30" fill="#009246"/><rect x="20" width="20" height="30" fill="#fff"/><rect x="40" width="20" height="30" fill="#CE2B37"/></svg>'
  };

  const LANGS = [
    { code: 'en', label: 'English',    href: '/'    },
    { code: 'fr', label: 'Français',   href: '/fr'  },
    { code: 'de', label: 'Deutsch',    href: '/de'  },
    { code: 'es', label: 'Español',    href: '/es'  },
    { code: 'nl', label: 'Nederlands', href: '/nl'  },
    { code: 'it', label: 'Italiano',   href: '/it'  }
  ];

  function currentLang() {
    const path = window.location.pathname;
    for (const l of LANGS) {
      if (l.code === 'en') continue;
      if (path.startsWith('/' + l.code + '/') || path === '/' + l.code) return l.code;
    }
    return 'en';
  }

  function injectSwitcher(){
    const header = document.querySelector('sticky-header, header, [class*="header"][class*="section"]');
    if (!header) return;
    if (document.querySelector('.b2s-lang-switcher')) return;

    const wrap = document.createElement('div');
    wrap.className = 'b2s-lang-switcher';
    const current = currentLang();
    const currentLangObj = LANGS.find(l => l.code === current) || LANGS[0];

    wrap.innerHTML =
      '<button type="button" class="b2s-lang-switcher__toggle" aria-haspopup="true" aria-expanded="false" aria-label="Choose language">' +
        '<span class="b2s-lang-switcher__flag" aria-hidden="true">' + FLAGS[currentLangObj.code] + '</span>' +
        '<span class="b2s-lang-switcher__current">' + currentLangObj.code.toUpperCase() + '</span>' +
        '<svg class="b2s-lang-switcher__chev" width="10" height="6" viewBox="0 0 10 6" fill="none" aria-hidden="true"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<ul class="b2s-lang-switcher__menu" role="menu">' +
        LANGS.map(l =>
          '<li role="none"><a role="menuitem" href="' + l.href + '" hreflang="' + l.code + '" lang="' + l.code + '"' + (l.code === current ? ' class="is-current" aria-current="true"' : '') + '>' +
            '<span class="b2s-lang-switcher__flag" aria-hidden="true">' + FLAGS[l.code] + '</span>' +
            '<span class="b2s-lang-switcher__name">' + l.label + '</span>' +
          '</a></li>'
        ).join('') +
      '</ul>';

    const target =
      header.querySelector('.header__icons, [class*="header__icons"], [class*="header-icons"]') ||
      header.querySelector('details[id*="locale"]')?.parentElement ||
      header.querySelector('.header__inline-menu, nav') ||
      header;
    if (target) target.insertBefore(wrap, target.firstChild);

    const toggle = wrap.querySelector('.b2s-lang-switcher__toggle');
    toggle.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      const open = wrap.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function(e){
      if (!wrap.contains(e.target)) {
        wrap.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && wrap.classList.contains('is-open')) {
        wrap.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSwitcher);
  } else {
    injectSwitcher();
  }
  const obs = new MutationObserver(() => injectSwitcher());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
